import dataImportService from '../services/dataImportService'

export default {
	namespaced: true,
	actions: {
		async uploadActuals(context, params){
            // Send new data to server
            return await dataImportService.uploadActuals(
                params.PlantID,
                params.FileData,
                params.ConfirmedContinueReferences,
                params.FileReference
            );
		}
	}
}